import { c as _c } from "react/compiler-runtime";
import { BusrequestMapFilters, useBusrequestMapContext } from "@/app/[lng]/(mainPages)/buspartner/_components/busrequestmap-context";
import { ActiveBusRequest, BusRequest } from "@/types/busrequest";
import { isNearToLocation } from "@/utils/Utils";
import { addDays } from "date-fns/addDays";
import { endOfDay } from "date-fns/endOfDay";
import { isAfter } from "date-fns/isAfter";
import { isBefore } from "date-fns/isBefore";
import { startOfDay } from "date-fns/startOfDay";
import { useMemo } from "react";
import { api } from "@/utils/trpc/react";
import { type GeoLocation } from "@/types/location";
function filterBusrequests(requests: ActiveBusRequest[], {
  typeFilter,
  startDateRangeFilter: startDateFilter,
  endDateRangeFilter: endDateFilter,
  startLocationFilter,
  endLocationFilter
}: BusrequestMapFilters) {
  /*
  console.log(
    "Current start location filter: " +
      startLocationFilter.location?.address +
      ", Range: " +
      startLocationFilter.radiusKm,
    "Current end location filter: " +
      endLocationFilter.location?.address +
      ", Range: " +
      endLocationFilter.radiusKm,
    "Current start date range is from " +
      (startDateFilter[0]
        ? format(startDateFilter[0], "dd.MM.yyyy")
        : "undefined") +
      " to " +
      (startDateFilter[1]
        ? format(startDateFilter[1], "dd.MM.yyyy")
        : "undefined"),
    "Current end date range is from " +
      (endDateFilter[0]
        ? format(endDateFilter[0], "dd.MM.yyyy")
        : "undefined") +
      " to " +
      (endDateFilter[1] ? format(endDateFilter[1], "dd.MM.yyyy") : "undefined"),
    "Current filter is " + String(typeFilter),
  );
  */

  if (!startDateFilter[0] && !startDateFilter[1] && !endDateFilter[0] && !endDateFilter[1] && !startLocationFilter.location && !endLocationFilter.location && (!typeFilter || typeFilter?.length === 0)) {
    return requests;
  }
  return requests.reduce((acc: ActiveBusRequest[], busRequest) => {
    // Remove all busrequest that don't fit into the category
    const includesRequestType = typeFilter?.includes(busRequest.category) ?? true;
    if (!includesRequestType) {
      return acc;
    }

    // Remove all busrequest that don't fit into the start date range
    const busReqStartDate = new Date(busRequest.start.date);
    const isInStartDateRange = (startDateFilter[0] ? isAfter(busReqStartDate, addDays(endOfDay(startDateFilter[0]), -1)) : true) && (startDateFilter[1] ? isBefore(busReqStartDate, addDays(startOfDay(startDateFilter[1]), 1)) : true);
    if (!isInStartDateRange) {
      return acc;
    }

    // Remove all busrequest that don't fit into the end date range
    const busReqEndDate = new Date(busRequest.end.date);
    const isInEndDateRange = (endDateFilter[0] ? isAfter(busReqEndDate, addDays(endOfDay(endDateFilter[0]), -1)) : true) && (endDateFilter[1] ? isBefore(busReqEndDate, addDays(startOfDay(endDateFilter[1]), 1)) : true);
    if (!isInEndDateRange) {
      return acc;
    }
    if (startLocationFilter.location && !isNearToLocation(busRequest.start.address.location, startLocationFilter.location.location, (startLocationFilter.radiusKm ?? 100) * 1000)) {
      return acc;
    }
    if (endLocationFilter.location && !isNearToLocation(busRequest.end.address.location, endLocationFilter.location.location, (endLocationFilter.radiusKm ?? 100) * 1000)) {
      return acc;
    }
    return [...acc, busRequest];
  }, []);
}
export function useFilteredBusrequests() {
  const $ = _c(3);
  const request = api.busrequest.GetRelevantBusrequests.useQuery();
  const filterState = useBusrequestMapContext();
  let t0;
  if ($[0] !== filterState || $[1] !== request.data) {
    t0 = filterBusrequests(request.data ?? [], {
      ...filterState
    });
    $[0] = filterState;
    $[1] = request.data;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const filteredData = t0;
  return filteredData;
}
export function useFilteredNearBusrequests(location) {
  const $ = _c(3);
  const request = api.busrequest.GetNearRequests.useQuery(location);
  const filterState = useBusrequestMapContext();
  let t0;
  if ($[0] !== filterState || $[1] !== request.data) {
    t0 = filterBusrequests(request.data ?? [], {
      ...filterState
    });
    $[0] = filterState;
    $[1] = request.data;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const filteredData = t0;
  return filteredData;
}